<template>
    <div class="main_container">
        <div id="background">
            <div id="base_info" style="margin-bottom: 20px;">
                <li id="line_title">기본정보</li>
                <div id="info_container">
                    <li id="info_title">아이디</li>
                    <label id="userinfo_text" v-text="user_id" />
                </div>
                <div id="info_container">
                    <li id="info_title">계좌 정보</li>
                    <label id="userinfo_text" v-html="bankAccount ? bankAccount.replace(/ /g, '&nbsp;&nbsp;') : '계좌가 올바르지 않습니다.'" />
                </div>
                <div id="info_container">
                    <li id="info_title">전화번호</li>
                    <label id="userinfo_text" v-text="user_phone" />
                </div>
            </div>
            <div id="change_nick" style="margin-bottom: 20px;">
                <li id="line_title">정보변경</li>
                <div id="info_container">
                    <li id="info_title">변경할 닉네임</li>
                    <input id="short_input_round_box" placeholder="2~8글자" v-model="state.nickname" />
                    <button id="short_btn" @click="CheckNick()">중복 확인</button>
                </div>
            </div>
            <div id="change_pw">
                <li id="line_title">비밀번호 변경</li>
                <div id="info_container">
                    <li id="info_title">현재 비밀번호</li>
                    <input id="info_input_round_box" type="password" v-model="state.old_pw" />
                </div>
                <div id="info_container">
                    <li id="info_title">바꿀 비밀번호</li>
                    <input id="info_input_round_box" type="password" placeholder="6자리 이상 영문/숫자/특수문자"
                        v-model="state.new_pw" />
                </div>
                <div id="info_container">
                    <li id="info_title">바꿀 비밀번호 확인</li>
                    <input id="info_input_round_box" type="password" v-model="state.pw_confirm" />
                </div>
            </div>
            <button id="btn" @click="ChangeInfo()">변경 적용</button>
        </div>
    </div>
</template>

<script>
import store from '../../js/store.js'
import { reactive } from '@vue/reactivity'
import Swal from "sweetalert2";
import API from '@/components/js/API';

export default {
        name: "popup_userinfo",
        data() {
            return {
                user_id: store.state.user.id,
                bankAccount: store.state.user.account || '',
                user_phone: store.state.user.phone,
                nick_check : false,
                state : reactive({
                    nickname: '',
                    old_pw: '',
                    new_pw: '',
                    pw_confirm: ''
                }),
                form: {
                    
                }
            }
        },
        methods:{
            CheckNick()
            {
                if (this.state.nickname.length > 0)
                {
                    var inputNick = this.state.nickname.trim();
                    if (inputNick.length < 2 ||inputNick.length > 8) {
                        Swal.fire({
                            title: '중복 확인',
                            icon: 'error',
                            text: '닉네임은 2~8자로 작성해야 합니다.',
                        }).then(this.nick_check = false);
                        return;
                    }
                    this.form.nickname = this.state.nickname;
                    API.AxiosPost('api/member/checkNick', this.form, true,
                        (res) => {
                            console.log(res);
                            if (res.status == 200) {
                                switch (res.data.code) {
                                    case '200':
                                        this.nick_check = true;
                                        Swal.fire({
                                            title: '중복 확인',
                                            icon: 'success',
                                            text: '사용 가능한 닉네임입니다.',
                                        });
                                        break;
                                    default:
                                    case '301':
                                        this.nick_check = false;
                                        Swal.fire({
                                            title: '중복 확인',
                                            icon: 'error',
                                            text: '이미 사용 중인 닉네임입니다.',
                                        });
                                        break;
                                }
                            }
                            else
                            {
                                Swal.fire({
                                        icon: 'error',
                                        html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                                    });
                            }
                        }
                    )
                }
            },
            ChangeInfo()
            {
                if(this.state.old_pw.length == 0)
                {
                    Swal.fire({
                        //title: '비밀번호 필요',
                        icon: 'error',
                        text: '정보 변경을 하려면 현재 비밀번호를 입력해야 합니다.',
                    });
                    return;
                }
                
                if(this.state.nickname.length > 0 && this.state.new_pw.length == 0)
                {
                    if (this.nick_check == false) {
                        Swal.fire({
                            title: '닉네임 오류',
                            icon: 'error',
                            text: '닉네임 중복을 확인해야 합니다.',
                        });
                        return;
                    }
                    this.form = {
                        user_id : store.state.user.id,
                        old_pw : this.state.old_pw,
                        nick : this.state.nickname
                    }
                }

                else if(this.state.new_pw.length > 0 && this.state.nickname.length == 0)
                {
                    if (this.state.new_pw != this.state.pw_confirm || this.state.pw_confirm.length == 0) {
                        Swal.fire({
                            title: '비밀번호 오류',
                            icon: 'error',
                            text: '비밀번호가 일치하지 않습니다.',
                        });
                        return;
                    }
                    
                    this.form = {
                        user_id : store.state.user.id,
                        old_pw : this.state.old_pw,
                        new_pw : this.state.new_pw
                    }
                }

                else if(this.state.new_pw.length > 0 && this.state.nickname.length > 0)
                {
                    if (this.nick_check == false) {
                        Swal.fire({
                            title: '닉네임 오류',
                            icon: 'error',
                            text: '닉네임 중복을 확인해야 합니다.',
                        });
                        return;
                    }
                    if (this.state.new_pw != this.state.pw_confirm || this.state.pw_confirm.length == 0) {
                        Swal.fire({
                            title: '비밀번호 오류',
                            icon: 'error',
                            text: '비밀번호가 일치하지 않습니다.',
                        });
                        return;
                    }

                    this.form = {
                        user_id : store.state.user.id,
                        nick : this.state.nickname,
                        old_pw : this.state.old_pw,
                        new_pw : this.state.new_pw
                    }
                }

                API.AxiosPost('api/member/changeInfo', this.form, true,
                    (res) => {
                        console.log(res);
                        if (res.status == 200) {
                            switch (res.data.code) {
                                case '200':
                                    this.id_check = true;
                                    Swal.fire({
                                        title: '정보 수정 완료',
                                        icon: 'success',
                                        text: '정상적으로 변경되었습니다.',
                                    });
                                    this.state.old_pw = '';
                                    if (this.nick_check && this.state.nickname.length > 0)
                                    {
                                        store.state.user.nickname = this.state.nickname;
                                        this.$root.Nick = store.state.user.nickname;
                                        this.state.nickname = '';
                                        this.nick_check = false;
                                    }
                                    if (this.state.new_pw.length > 0)
                                    {
                                        this.state.new_pw = '';
                                        this.state.pw_confirm = '';
                                    }
                                    
                                    break;
                                case '307':
                                    this.id_check = false;
                                    Swal.fire({
                                        title: '정보 수정 실패',
                                        icon: 'error',
                                        html: '현재 비밀번호가 일치하지 않습니다.',
                                    });
                                    break;
                                default:
                                case '301':
                                    this.id_check = false;
                                    Swal.fire({
                                        title: '정보 수정 실패',
                                        icon: 'error',
                                        html: '정상적으로 진행되지 않았습니다.<br>잠시 후 다시 시도해 주세요.',
                                    });
                                    break;
                            }
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                            });
                            console.log("return status : " + res.status);
                        }
                    }
                )
            }
        }
    };

</script>

<style>
.userinfo_container {
  width: 520px;
  max-height: calc(100vh - 200px);
  
  margin: 0px auto;
  
}
#line_title{
    width: 440px;
    height: 40px;
    margin: 0px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    color: white;
}
#info_container{
    width: 440px;
    height: 40px;
    margin: 5px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
#info_title{
    float: left;
    width: 180px;
    height: 100%;
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-align: left;
    margin-top: 20px;
}

#info_input_round_box{
    float: left;
    height: 40px;
    width: 240px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    padding-left: 20px;
    margin-left: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
#info_input_round_box::placeholder{
    font-size: 13px;
    font-style: italic;
}
#short_input_round_box{
    float: left;
    height: 40px;
    width: 160px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    padding-left: 20px;
    margin-left: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
#short_input_round_box::placeholder{
    font-size: 13px;
    font-style: italic;
}
#short_btn{
    width: 70px;
    height: 100%;
    border: 1px;
    margin-left: 10px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    font-size: 13px;
}
#btn{
    height: 40px;
    width: 250px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
#userinfo_text{
    width: 360px;
    margin-right: 20px;
    margin-left: 20px;
    font-weight: bold;
    font-family: 'HYGothic';
    font-size: 16px;
    text-align: right;
    color: white;
    
}
</style>@/components/js/API.js